<script setup lang="ts">
import { computed } from "vue";
import Spinner from "@/components/helpers/Spinner.vue";
import type { Props } from "./types.ts";

defineOptions({
  name: "RegistrationLoading",
});

const props = withDefaults(defineProps<Props>(), {
  title: "Loading",
  message: "",
  isLoading: false,
});

const hasMessage = computed<boolean>(() => props.message.trim().length > 0);
</script>

<template>
  <div class="w-full mx-auto md:px-8 md:mb-8">
    <div
      class="px-4 py-6 bg-white border-t border-gray-200 dashboard sm:grid sm:grid-cols-12 sm:gap-6 md:gap-12 sm:px-8 md:p-12 md:border md:rounded"
    >
      <div class="col-span-12">
        <template v-if="isLoading">
          <spinner>
            <template #spinnercontent>
              <p v-if="hasMessage" id="loading-message-id" class="text-gray-600">
                {{ message }}
              </p>
            </template>
          </spinner>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
